// Central GSAP setup. Import `gsap` and `ScrollTrigger` from here (never
// directly) so the plugin is registered exactly once and every section shares
// the same motion language defined below.
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Shared motion tokens — keep the whole page feeling like one system.
// Easing and durations are tuned to the reference site's slow, smooth glide.
export const EASE = "power3.out"; // decelerating ease used for every reveal
export const DUR = 0.9; // base reveal duration (seconds)
export const STAGGER = 0.12; // gap between staggered children
export const DISTANCE = 48; // px a block travels while sliding up

// The scroll position at which a reveal fires: element top passes ~82% down
// the viewport. Consistent trigger point = consistent rhythm between sections.
export const START = "top 82%";

export { gsap, ScrollTrigger };
